import CAAA1020RequestModel from '@/api/data/CAA/CAAA1020/CAAA1020RequestModel'
import CAAA1020ResponseModel from '@/api/data/CAA/CAAA1020/CAAA1020ResponseModel'
import moment from 'moment'

import RestService from '@/common/RestService'
import ApiUrlConstants from '@/common/ApiUrlConstants'
import ValidationUtil from '@/common/utils/ValidationUtil'
import CommonUtil from '@/common/utils/CommonUtil'
import Store from '@/common/utils/Store'

const FORMAT_DATE = 'YYYY/MM/DD'
const ADD_MONTH = 2
export default class CAAG1020Service {
  private caaa1020RequestModel = new CAAA1020RequestModel()

  /**
   * CAAA1020 API処理呼出
   * @param cntctNo
   * @param cmpnyNo
   * @param persnInfoAgrAvail
   * @param critDay
   * @returns response model
   */
  public async callAPICAAA1020(
    cntctNo: string,
    cmpnyNo: string,
    persnInfoAgrAvail: string,
    critDay: string
  ): Promise<CAAA1020ResponseModel> {
    this.caaa1020RequestModel.cntctNo = cntctNo
    this.caaa1020RequestModel.cmpnyNo = cmpnyNo
    this.caaa1020RequestModel.persnInfoAgrAvail = Number(persnInfoAgrAvail)
    this.caaa1020RequestModel.critDay = critDay
    const caaa1020ResponseModel: CAAA1020ResponseModel = <
      CAAA1020ResponseModel
    > await RestService.post(ApiUrlConstants.CAAA1020, this.caaa1020RequestModel)
    return caaa1020ResponseModel
  }

  /**
   * 入力日付が現在日付の2ヶ月後日付範囲内であるかチェック
   * @param critDay
   * @returns boolean
   */
  public isDateInRange(critDay: string): boolean {
    const currentDate = moment().format(FORMAT_DATE)
    const maxDate = moment().add(ADD_MONTH, 'month').format(FORMAT_DATE)
    return (
      moment(critDay).isSameOrAfter(currentDate) &&
      moment(critDay).isSameOrBefore(maxDate)
    )
  }

  /**
   * 入力項目バリデーション
   * @param cntctNo
   * @param cmpnyNo
   * @param persnInfoAgrAvail
   * @param critDay
   * @returns isValid boolean
   */
  public validationInput(
    cntctNo: string,
    cmpnyNo: string,
    persnInfoAgrAvail: string,
    critDay: string
  ): boolean {
    let isValid = false
    const errorValid = []

    while (true) {
      if (ValidationUtil.isNotEmptyValid(critDay) === false) {
        errorValid.push({
          code: 'MSGCAAG1020WF001',
          message: CommonUtil.getMessage('MSGCAAG1020WF001', [])
        })
        break
      }

      if (ValidationUtil.isNotEmptyValid(cntctNo) === false) {
        errorValid.push({
          code: 'MSGCAAG1020WF002',
          message: CommonUtil.getMessage('MSGCAAG1020WF002', [])
        })
        break
      }
      if (ValidationUtil.isHankakuNumValid(cntctNo) === false) {
        errorValid.push({
          code: 'MSGCAAG1020WF003',
          message: CommonUtil.getMessage('MSGCAAG1020WF003', [])
        })
        break
      }
      if (ValidationUtil.isLengthValid(7, cntctNo) === false) {
        errorValid.push({
          code: 'MSGCAAG1020WF004',
          message: CommonUtil.getMessage('MSGCAAG1020WF004', [])
        })
        break
      }

      if (ValidationUtil.isNotEmptyValid(cmpnyNo) === false) {
        errorValid.push({
          code: 'MSGCAAG1020WF005',
          message: CommonUtil.getMessage('MSGCAAG1020WF005', [])
        })
        break
      }
      if (ValidationUtil.isHankakuNumValid(cmpnyNo) === false) {
        errorValid.push({
          code: 'MSGCAAG1020WF006',
          message: CommonUtil.getMessage('MSGCAAG1020WF006', [])
        })
        break
      }
      if (ValidationUtil.isLengthValid(7, cmpnyNo) === false) {
        errorValid.push({
          code: 'MSGCAAG1020WF007',
          message: CommonUtil.getMessage('MSGCAAG1020WF007', [])
        })
        break
      }

      if (ValidationUtil.isNotEmptyValid(persnInfoAgrAvail) === false) {
        errorValid.push({
          code: 'MSGCAAG1020WF008',
          message: CommonUtil.getMessage('MSGCAAG1020WF008', [])
        })
        break
      }

      if (errorValid.length === 0) {
        break
      }
    }

    if (errorValid.length > 0) {
      isValid = true
      Store.setResponseErrors(errorValid)
    }

    return isValid
  }
}
